import { ComponentPropsWithRef } from "react";
import { shade900 } from "../../../../styles/tokens";

export const PlaylistIcon = (props: ComponentPropsWithRef<"svg">) => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8.41038 38.4639H39.5896C39.8161 38.4639 40 38.2704 40 38.0321V15.9223C40 15.684 39.8161 15.4906 39.5896 15.4906H8.41038C8.18385 15.4906 8 15.684 8 15.9223V38.0321C8 38.2704 8.18385 38.4639 8.41038 38.4639Z"
      fill="currentColor"
    />
    <path
      d="M21.8208 32.2757L17.7243 28.1791C17.5586 28.0134 17.5586 27.7441 17.7243 27.5784L19.5265 25.7761C19.6922 25.6104 19.9616 25.6104 20.1273 25.7761L21.8208 27.4696C21.9865 27.6353 22.2559 27.6353 22.4216 27.4696L28.5669 21.3243C28.7326 21.1586 29.002 21.1586 29.1677 21.3243L30.97 23.1266C31.1357 23.2923 31.1357 23.5617 30.97 23.7274L22.4216 32.2757C22.2559 32.4414 21.9865 32.4414 21.8208 32.2757Z"
      fill={shade900}
    />
    <path
      d="M33.3828 10H14.6168C14.3902 10 14.2064 10.1933 14.2064 10.4317V13.022C14.2064 13.2604 14.3902 13.4537 14.6168 13.4537H33.3828C33.6094 13.4537 33.7932 13.2604 33.7932 13.022V10.4317C33.7932 10.1933 33.6094 10 33.3828 10Z"
      fill="currentColor"
    />
  </svg>
);
